import { createContext, useContext } from 'react'

export interface RailPageShellCollapseState {
  collapsed: boolean
  useInitials?: boolean
}

export const RailPageShellCollapseContext = createContext<RailPageShellCollapseState | null>(null)

export const useRailPageShellCollapse = (): RailPageShellCollapseState =>
  useContext(RailPageShellCollapseContext) ?? { collapsed: false }
